import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

interface ContainerProps {
  height?: string;
  maxWidth?: string;
  minHeight?: string;
}

export const Container = styled(Box)<ContainerProps>(
  ({ theme, height, maxWidth, minHeight }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: height || 'calc(100vh - 90px)',
    minHeight: minHeight || 'unset',
    maxWidth: maxWidth || '1200px',
    margin: '0 auto',
    padding: '50px 40px 40px 280px',

    '.MuiTypography-h3': {
      marginBottom: '30px',
    },

    [theme.breakpoints.down('xl')]: {
      padding: '50px 30px 40px 270px',
    },

    [theme.breakpoints.down('lg')]: {
      padding: '50px 30px 40px 270px',
      maxWidth: '100%',
    },

    [theme.breakpoints.down('md')]: {
      padding: '50px 30px 40px 250px',
      maxWidth: '100%',
    },

    [theme.breakpoints.down(800)]: {
      height: 'unset',
      padding: '40px 20px 20px 240px',
    },

    [theme.breakpoints.down('sm')]: {
      minHeight: 'unset',
      padding: '80px 20px 20px 20px',
      maxWidth: '100%',

      '.MuiTypography-h3': {
        marginBottom: '20px',
      },
    },

    [theme.breakpoints.down('xs')]: {
      padding: '60px 16px 16px 16px',
    },
  }),
);
